<template lang="pug">
  .container-error
    .item
      h1
        font-awesome-icon.item-icon(icon="hand-paper")
        span {{ $t('ERROR 403!')}}
    .item.description
      h4.warning {{ $t('You do not have sufficient right to perform this action.')}}
      h6 {{ $t(this.$store.state.Error.axios_error.data) }}
      h6 {{ this.$store.state.Error.axios_error.config.url}}
    .item
    .item.item-acknowledge
      el-button(id="Error403-okButton" type="warning", size="small", @click="ackError", plain)
        span {{ $t('OK') }}
</template>
<script>
export default {
  props: ['error'],
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
    ackError () {
      this.$emit('ackError')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
@import "./error.scss";
</style>



// WEBPACK FOOTER //
// src/components/Error/error403.vue